import createAxiosInstance from "./LambdaApiUsabilidad";

export async function fetchSendReporteEmail(email, date, tokenProd) {
  const axiosInstance = await createAxiosInstance();
  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: `/reclasificacion/reporte/usabilidad?email=${email}&date=${date}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tokenProd}`,
    },
  };

  return axiosInstance(requestConfig);
}
